var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('posts',{attrs:{"poolPreview":_vm.poolId,"previewSettings":{
      posts_per_chunk: _vm.posts_per_chunk,
      interval: _vm.interval,
      fontSize: _vm.fontSize,
      arrangement: _vm.arrangement
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }